import { useRequiredParams } from '@pba/react-router';
import { OrganizationLayout, OrganizationsGivings } from 'features/organizations';
import { useGetPathToEntityDetail } from 'pages/hooks';

const PageOrganizationsGivings = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <OrganizationLayout organizationId={organizationId}>
      {(organization) => (
        <OrganizationsGivings
          getPathToGivingDetail={(id) => getPathToEntityDetail(id, { entityType: 'giving' })}
          organization={organization}
        />
      )}
    </OrganizationLayout>
  );
};

export default PageOrganizationsGivings;
